import { useQuery } from "@tanstack/react-query"
import { useTRPC } from "utils/trpc"

const useMetricConfiguration = ({ metricId }: { metricId: string }) => {
  const trpc = useTRPC()
  return useQuery(
    trpc.metrics.getMetricConfiguration.queryOptions({ metric_id: metricId })
  )
}

export default useMetricConfiguration
